module.exports = { "default": require("core-js/library/fn/symbol/iterator"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/babel-runtime/6.11.6/babel-runtime/core-js/symbol/iterator.js
 ** module id = 36
 ** module chunks = 0
 **/